import { createAction } from 'redux-act';
export var setPageTransitioning = createAction('SET_PAGE_TRANSITIONING');
export var serviceWorkerAwaitingActivation = createAction('SERVICE_WORKER_AWAITING_ACTIVATION');
export var acceptServiceWorkerUpdate = createAction('ACCEPT_SERVICE_WORKER_UPDATE');
export var dismissServiceWorkerUpdate = createAction('DISMISS_SERVICE_WORKER_UPDATE');